import React from 'react';
import AdminAuditLog from './AdminAuditLog';

// Thin wrapper — AdminAuditLog's own `clean` prop already does everything
// (its own page chrome, sidebar highlight, heading text, curated login/
// logout/app-access/password-reset/authenticator-setup filtering). Kept
// as a separate route/page rather than a mode toggle on the Audit Log
// page itself, so "clean, all users" and "full detail" are two distinct,
// bookmarkable destinations — see AdminUserDetail.jsx's embedded Activity
// section for the per-user equivalent of this same curated view.
export default function UserActivity() {
  return <AdminAuditLog clean />;
}
